import dayjs from 'dayjs';
import React from 'react';
import { Link } from 'react-router-dom';
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString';
import { routing } from '@utils/routing';
import { useSubscription } from './useSubscription';
export const usePastDueSubscriptionErrorBanner = ({ withLink = false, } = {}) => {
    const { activeSubscription } = useSubscription();
    const isActive = !!activeSubscription && activeSubscription.status === 'PAST_DUE';
    const pastDueDate = activeSubscription?.activeTo
        ? dayjs(activeSubscription?.activeTo).add(3, 'day')
        : null;
    const getContent = () => {
        if (!isActive) {
            return null;
        }
        const updateText = withLink ? (React.createElement(Link, { to: routing.settings.billing.self }, "Update your payment method")) : ('Update your payment method');
        return (React.createElement(React.Fragment, null,
            "Payment for Fourthwall Pro subscription failed. Please ",
            updateText,
            " or you\u2019ll",
            "lose access to your Pro benefits",
            pastDueDate && (React.createElement(React.Fragment, null,
                ' ',
                "on ",
                React.createElement(TimezonedDateString, { date: pastDueDate }))),
            "."));
    };
    return {
        isActive,
        content: getContent(),
    };
};
